export enum EnergyValveControlMode {
  Undefined = 0,
  PositionControl = 1, // PositionControl
  FlowControl = 2, // FlowControl
  PowerControl = 3,  //PowerControl
}